import { useQuery } from '@tanstack/react-query'
import { getWebBuilderDetails } from '@/features/site-pages/api'

export function useProjectSettingsQuery(uniqueUrl, options = {}) {
  return useQuery({
    queryKey: ['projectSettings', uniqueUrl],
    queryFn: () => getWebBuilderDetails(uniqueUrl, 'home', 'builder'),
    enabled: !!uniqueUrl,
    ...options,
  })
}

